module.exports = __webpack_public_path__ + "img/09n.97ae2339.png";